module.exports = __webpack_public_path__ + "db2963457101cbb00723e8ec2e3e2a4a.svg";